// src/components/WhatsAppButton.jsx
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

export const WhatsAppButton = () => {
  const phoneNumber = "919923314198";
  const message = "Hello! I’d like to know more about your services."; // Optional preset message

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        backgroundColor: "#25D366",
        color: "white",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "30px",
        zIndex: "1000",
        boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
        textDecoration: "none",
      }}
    >
      <FaWhatsapp />
    </a>
  );
};

